/**
 * Misc small behaviors that don’t justify their own module (keep it small).
 *
 * Put here:
 * - Attribute-driven helpers (e.g. [setBackground])
 * - Small, isolated DOM behaviors
 *
 * Avoid here:
 * - Anything that grows big: split into a dedicated module as soon as it does
 */
export function initMisc() {
	// Background images
	document.querySelectorAll("[setBackground]").forEach((el) => {
		const url = el.getAttribute("setBackground");
		if (url) {
			el.style.backgroundImage = `url(${url})`;
		}
	});


	// Counter (if exists)
	const counters = document.querySelectorAll(".counter, .countup");
	const CountUpClass = window.CountUp || window.countUp?.CountUp;

	if (counters.length && CountUpClass) {
		// Custom ease-out curve with a pronounced, smooth slow-down at the end
		const easeOutCubic = (t, b, c, d) => {
			const p = t / d - 1;
			return c * (p * p * p + 1) + b;
		};

		const easeOutQuart = (t, b, c, d) => {
			const p = t / d - 1;
			return -c * (p * p * p * p - 1) + b;
		};

		const parseCounter = (el) => {
			const dataNum = el.dataset?.number;
			const duration = parseFloat(el.dataset?.duration) || 3;
			const easingType = el.dataset?.easing || "cubic";
			const easingFn = easingType === "quart" ? easeOutQuart : easeOutCubic;

			if (dataNum !== undefined && dataNum !== "") {
				return {
					endVal: parseFloat(dataNum),
					options: {
						duration,
						useEasing: true,
						easingFn,
						smartEasingThreshold: parseFloat(el.dataset?.smartEasingThreshold) || 999999,
						smartEasingAmount: parseFloat(el.dataset?.smartEasingAmount) || 333,
						separator: el.dataset?.separator || ".",
						decimal: el.dataset?.decimal || ",",
						prefix: el.dataset?.prefix || "",
						suffix: el.dataset?.suffix || "",
					},
				};
			}

			const html = el.innerHTML.trim();
			const match = html.match(/(^|[^0-9,.]*)([0-9]+(?:[.,][0-9]+)?)(.*)/s);
			if (!match) return null;

			const prefix = match[1];
			const numStr = match[2];
			const suffix = match[3];

			let decimalPlaces = 0;
			let decimal = ".";
			let separator = ".";
			let endVal = 0;
			let formattingFn = null;

			const isDecimalComma = numStr.includes(",") && !numStr.includes(".");
			const isThousandsDot = numStr.includes(".") && numStr.split(".")[1].length === 3;

			if (isDecimalComma) {
				const parts = numStr.split(",");
				decimalPlaces = parts[1].length;
				decimal = ",";
				separator = ".";
				endVal = parseFloat(`${parts[0]}.${parts[1]}`);
			} else if (isThousandsDot) {
				separator = ".";
				endVal = parseFloat(numStr.replace(/\./g, ""));
			} else if (numStr.includes(".")) {
				const parts = numStr.split(".");
				decimalPlaces = parts[1].length;
				endVal = parseFloat(numStr);
			} else {
				endVal = parseInt(numStr, 10);
				if (numStr.length > 1 && numStr.startsWith("0")) {
					formattingFn = (n) => String(Math.floor(n)).padStart(numStr.length, "0");
				}
			}

			const options = {
				duration,
				useEasing: true,
				easingFn,
				smartEasingThreshold: parseFloat(el.dataset?.smartEasingThreshold) || 999999,
				smartEasingAmount: parseFloat(el.dataset?.smartEasingAmount) || 333,
				separator,
				decimal,
				decimalPlaces,
				prefix,
				suffix,
				...(formattingFn ? { formattingFn } : {}),
			};

			return { endVal, options };
		};

		const startCounter = (el) => {
			const parsed = parseCounter(el);
			if (!parsed) return;

			const targetId = el.id || el;
			const countUp = new CountUpClass(targetId, parsed.endVal, parsed.options);
			if (!countUp.error) {
				countUp.start();
			} else {
				console.error(countUp.error);
			}
		};

		if (typeof IntersectionObserver !== "undefined") {
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting && !entry.target.classList.contains("done")) {
							entry.target.classList.add("done");
							startCounter(entry.target);
							observer.unobserve(entry.target);
						}
					});
				},
				{ threshold: 0.15 }
			);

			counters.forEach((c, idx) => {
				if (!c.id) {
					c.id = `counter-${idx + 1}`;
				}
				observer.observe(c);
			});
		} else {
			counters.forEach((c, idx) => {
				if (!c.id) {
					c.id = `counter-${idx + 1}`;
				}
				startCounter(c);
			});
		}
	}

	// new MappingListener({
	// 	selector: ".header-contact",
	// 	mobileWrapper: ".mobile-nav-wrap",
	// 	mobileMethod: "appendTo",
	// 	desktopWrapper: ".site-menu-toggle",
	// 	desktopMethod: "insertBefore",
	// 	breakpoint: 1200.1,
	// }).watch();



}